import type {Colors} from '@travel-frontend/themes';

import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const OverlayTrigger = styled.button<{textColor?: keyof Colors}>(
  ({theme, textColor = 'contentInversePrimary'}) => css`
    all: unset;
    display: inline-flex;
    width: min-content;
    white-space: nowrap;
    align-items: center;
    cursor: pointer;
    height: 26px;
    border-radius: 2px;

    ${theme.typography.labelSmallBold};
    color: ${theme.colors[textColor]};

    &:focus {
      outline: none;
    }
  `
);
